import {
  Box,
  Card,
  Form,
  Grid,
  IconBadge,
  RadioButton,
  Text,
  WizardStep,
  WizardStepRenderParams,
  useOnNext,
} from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import {
  categoryTemplateList,
  validateMandatoryFields,
} from 'modules/finance/lib/newSpendingPoliciesWizard'
import { WizardData, WizardDataField } from 'modules/finance/lib/policy_types'

const PolicyTemplateStep = ({ data, onDataChanged }: WizardStepRenderParams<WizardData>) => {
  const handleNext = async () => {
    const mandatoryFields: WizardDataField[] = ['template']

    const { invalidFields, dataWithErrors } = validateMandatoryFields(mandatoryFields, data)

    onDataChanged(dataWithErrors)

    if (invalidFields.length) {
      return Promise.reject()
    }
  }

  const handleCardClick = (value: string) => {
    const categoryTemplate = categoryTemplateList().find((template) => template.value === value)

    const selectedCategory = data.availableCategories.find(
      (availableCategory) => availableCategory.identifier === value
    )

    const categories = selectedCategory
      ? [selectedCategory].map((c) => {
          return {
            value: c.value.toString(),
            label: c.label.toString(),
            amountCents: '',
            timeFrame: '',
            description: '',
          }
        })
      : []

    const subcategories = data.availableSubcategories
      .filter(
        (availableSubcategory) =>
          availableSubcategory.parentCategoryId === selectedCategory?.value.toString()
      )
      .map((subcategory) => {
        return {
          parentId: subcategory?.parentCategoryId,
          value: subcategory.value?.toString(),
          label: subcategory.label,
          amountCents: '',
          timeFrame: '',
          description: '',
          errors: {},
        }
      })

    if (categoryTemplate) {
      onDataChanged({
        ...data,
        template: value,
        icon: categoryTemplate.icon,
        name: categoryTemplate.title,
        categories,
        subcategories,
      })
    }
  }
  useOnNext(handleNext)

  return (
    <Box gap="s16" flexDirection="column" paddingTop="s40" maxWidth="s600">
      <Box gap="s24">
        <Box gap="s8">
          <Text.Header2 weight="semibold">
            {i18n.t('spending_policies.wizard.steps.policy_template.title')}
          </Text.Header2>

          <Text.Normal>
            {i18n.t('spending_policies.wizard.steps.policy_template.description')}
          </Text.Normal>
        </Box>
      </Box>
      <Box gap="s40">
        <Form padding="s0" notRounded>
          {data.errors && (
            <Box alignItems="flexStart">
              <Text size="200" color="radicalRed1000" capitalize>
                {data.errors.template}
              </Text>
            </Box>
          )}
          <Grid variant="fixed">
            {categoryTemplateList().map((category) => {
              return (
                <Box
                  aria-label="template-card"
                  key={category.value}
                  gridColSpan={{ xxs: 12, s: 6, m: 6 }}
                >
                  <Card onClick={() => handleCardClick(String(category.value))}>
                    <Card.Content>
                      <Box
                        flexDirection="row"
                        justifyContent="spaceBetween"
                        width="full"
                        gap="s16"
                        paddingY="s8"
                      >
                        <Box
                          flexDirection="row"
                          justifyContent="spaceBetween"
                          gap="s12"
                          alignItems="center"
                        >
                          <IconBadge
                            icon={category.icon}
                            color={category.badgeColor}
                            iconColor={category.color}
                          />
                          <Text.Header2>{category.title}</Text.Header2>
                        </Box>
                        <RadioButton
                          key="templates"
                          size="medium"
                          onChange={() => {}}
                          value={String(category.value)}
                          checked={category.value === data.template}
                        />
                      </Box>
                    </Card.Content>
                  </Card>
                </Box>
              )
            })}
          </Grid>
        </Form>
      </Box>
    </Box>
  )
}

export const policyTemplateStep = (): WizardStep<WizardData> => ({
  title: i18n.t('spending_policies.wizard.steps.policy_template.title'),
  nextText: i18n.t('common.next'),
  render: (props) => <PolicyTemplateStep {...props} />,
  isCompleted: () => true,
})
